import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-spring-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>Declutter and Boost Your Sales with Mercari Spring Items</title>
        <meta
          name='description'
          content='Make your spring cleaning profitable by setting aside in-season items to sell on Mercari. Here are some tips and tricks.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-spring-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-spring-items' />
        <meta property='og:title' content='Declutter and Boost Your Sales with Mercari Spring Items' />
        <meta
          property='og:description'
          content='Make your spring cleaning profitable by setting aside in-season items to sell on Mercari. Here are some tips and tricks.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 20th, 2022' />
        <meta property='article:modified_time' content='April 20th, 2022' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
